import React from 'react';
import MuiRadio from '@mui/material/Radio';
import styled from 'styled-components';
import { COLORS } from '../design-system/settings/variables/Colors';
import { ANIMATIONS, pop } from '../design-system/settings/variables/Animation';

const CheckedIcon = styled.div`
  width: 20px;
  height: 20px;
  outline: 1px solid ${COLORS.greyBase};
  border: 4px solid ${COLORS.greyLight};
  border-radius: 50px;
  padding: 1px;
  color: ${COLORS.ctaPrimary};
  background-color: ${COLORS.greyDark};
  animation: ${pop} 0.4s ${ANIMATIONS.easing} both;
`;

const UncheckedIcon = styled.div`
  width: 20px;
  height: 20px;
  border: 1px solid ${COLORS.greyBase};
  border-radius: 50px;
  padding: 1px;
  background-color: ${COLORS.greyLight};
`;

const CheckedIconWhite = styled(CheckedIcon)`
  outline: 1px solid ${COLORS.whiteBase};
  border: 4px solid ${COLORS.ctaPrimary};
  color: ${COLORS.ctaPrimary};
  background-color: ${COLORS.whiteBase};
`;

const UncheckedIconWhite = styled(UncheckedIcon)`
  background-color: ${COLORS.whiteBase};
`;

const RadioBase = styled(MuiRadio).attrs({
  size: 'small',
  icon: <UncheckedIcon />,
  checkedIcon: <CheckedIcon />,
})``;

const RadioWhite = styled(MuiRadio).attrs({
  size: 'small',
  icon: <UncheckedIconWhite />,
  checkedIcon: <CheckedIconWhite />,
})``;

interface RadioProps {
  variant?: 'base' | 'white';
  className?: string;
  checked?: boolean;
}

const Radio: React.FC<RadioProps> = ({
  variant = 'base',
  className,
  checked,
}) => {
  switch (variant) {
    case 'base':
      return <RadioBase className={className} checked={checked} />;
    case 'white':
      return <RadioWhite className={className} checked={checked} />;
  }
};

export default Radio;
